module.exports = __webpack_public_path__ + "assets/img/lime_emr.e43308cf.png";